import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { resetToCurrentPeriod, shiftDate as shiftDateUtil } from '../utils/dateUtils';

const PeriodSelector = ({ config, period, customDate, onPeriodChange, onDateChange }) => {
  const { options = [], showDateNavigation = false } = config;

  const handlePeriodClick = (value) => {
    if (value === period) {
      onDateChange(resetToCurrentPeriod(value));
    } else {
      onPeriodChange(value);
    }
  };

  const handleShift = (direction, e) => {
    e.stopPropagation();
    onDateChange(shiftDateUtil(customDate, period, direction));
  };

  return (
    <div className="flex items-center gap-2">
      <div className="flex rounded shadow-sm">
        {options.map((opt, i) => {
          const isFirst = i === 0;
          const isLast = i === options.length - 1;
          const isActive = period === opt.value;
          const borderClass = isFirst
            ? 'rounded-l border'
            : isLast
              ? 'rounded-r border'
              : 'border-t border-b';
          return (
            <button
              key={opt.value}
              className={`px-2 py-1 text-xs font-medium ${borderClass} ${
                isActive
                  ? 'bg-primary text-white border-primary'
                  : 'bg-white text-primary border-gray-200 hover:bg-gray-50'
              }`}
              onClick={() => handlePeriodClick(opt.value)}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
      {showDateNavigation && (
        <div className="flex items-center">
          <button
            onClick={(e) => handleShift('prev', e)}
            className="px-1 py-0.5 border border-r-0 rounded-l text-gray-500 hover:bg-gray-100"
          >
            <FaChevronLeft className="w-2.5 h-2.5" />
          </button>
          <input
            type="date"
            value={customDate}
            onChange={(e) => { e.stopPropagation(); onDateChange(e.target.value); }}
            onClick={(e) => e.stopPropagation()}
            className="px-1 py-0.5 border-t border-b text-xs font-normal text-gray-700 w-28"
          />
          <button
            onClick={(e) => handleShift('next', e)}
            className="px-1 py-0.5 border border-l-0 rounded-r text-gray-500 hover:bg-gray-100"
          >
            <FaChevronRight className="w-2.5 h-2.5" />
          </button>
        </div>
      )}
    </div>
  );
};

export default PeriodSelector;
